"use strict";

Object.defineProperty(exports, "__esModule", {
  value: !0
}), exports.default = void 0;

var _ethers = require("ethers"),
    _default = function _default() {
  return (
    /**
    * Returns the string representation of a given hex value
    *
    * @param {string} hex The hex string
    * @param {string} [to='utf8'] The type to convert the hex from (supported types: 'utf8', 'number')
    * @return {radspec/evaluator/TypedValue}
    */
    function (hex) {
      var to = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : "utf8";
      return {
        type: "string",
        value: "number" === to ? _ethers.BigNumber.from(hex).toNumber() : _ethers.ethers.utils.toUtf8String(hex)
      };
    }
  );
};

exports.default = _default;